import { useTranslation } from 'react-i18next';

import type { LogStatus } from '../types/log.types';

// Color is an FE concern (status code → badge variant). The Korean label comes
// from the backend-served label catalog (`labels` ns), keyed by auditStatus.<CODE>.
const STYLE: Record<string, React.CSSProperties> = {
  SUCCESS: {
    color: '#16a34a',
    background: '#dcfce7',
    borderColor: '#86efac',
  },
  FAIL: {
    color: '#dc2626',
    background: '#fee2e2',
    borderColor: '#fca5a5',
  },
};

// A status the badge does not have colours for must still render. Without this the component read
// `.color` off `undefined` and crashed the whole table — a single unexpected status code would have
// taken down the screen rather than shown one odd-looking cell.
const FALLBACK_STYLE: React.CSSProperties = {
  color: '#4b5563',
  background: '#f3f4f6',
  borderColor: '#d1d5db',
};

export function LogStatusBadge({ status }: { status: LogStatus }) {
  const { t } = useTranslation('labels');
  const s = STYLE[status] ?? FALLBACK_STYLE;
  return (
    <span
      style={{
        display: 'inline-block',
        padding: '2px 10px',
        borderRadius: 4,
        fontSize: 12,
        fontWeight: 600,
        border: '1px solid',
        color: s.color,
        background: s.background,
        borderColor: s.borderColor,
      }}
    >
      {/* Degrade to the code itself, never to the lookup path. */}
      {t(`auditStatus.${status}`, { defaultValue: status })}
    </span>
  );
}
